module.exports = __webpack_public_path__ + "img/powered_by_stripe_icon.71cac5a2.png";